<span class="p-float-label">
    <p-dropdown [ngModel]="formControl['value']" class="p-inputtext-sm" [options]="options"
                [placeholder]="'button.select' | translate" optionLabel="{{optionsField || 'name'}}"
                inputId="{{id}}" (onChange)="onSelectChange($event)" [filter]="filter" filterBy="name"
                [showClear]="clearable" [appendTo]="appendTo ? appendTo : ''"
                [disabled]="formControl['disabled']"></p-dropdown>
    <label [htmlFor]="id" [innerHTML]="label ? label : ('field.'+field) | translate"></label>
    <app-form-input-error [show]="formControl.invalid && (formControl.dirty || formControl.touched)"
                          [required]="formControl.errors?.['required']"></app-form-input-error>
</span>
